<template>
  <div class="action-bar">
    <vs-button
      v-if="secondaryAction"
      destructive
      type="secondary"
      outline
      v-bind="secondaryAction.props"
      v-on="secondaryAction.on"
    />
    <vs-button
      :full-width="!secondaryAction"
      v-bind="primaryAction.props"
      v-on="primaryAction.on"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { Prop } from 'vue/types/options'
import VsButton from '@/components/vision/VsButton.vue'

type PrimaryAction = {
  props: { label: string; loading: boolean }
  on: { click(): void }
}

type SecondaryAction = PrimaryAction

export default defineComponent({
  name: 'ActionBar',
  components: { VsButton },

  props: {
    primaryAction: {
      type: Object as Prop<PrimaryAction>,
      required: true,
    },
    secondaryAction: {
      type: Object as Prop<SecondaryAction>,
      default: () => null,
    },
  },
})
</script>

<style scoped>
.action-bar {
  display: flex;
  justify-content: space-evenly;
  margin: 2rem 0;
  column-gap: 1rem;
}

:deep(button) {
  flex: 1;
}
</style>
